import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './home/home.component';
import { LayoutComponent } from './layouts/layout/layout.component';
import { environment } from 'src/environments/environment';
if(environment.dev_mode == 'TRUE'){
  console.log('devtrue')
  var routes: Routes = [

    //{ path: '', component: environment ,canActivate: [MsalGuard]}

  // , canActivate:[MsalGuard],
   { path: '', component: LayoutComponent, pathMatch: 'full', children: [
    { path: '', component: HomeComponent }
  ]},

];
}else{
  console.log('devfalse');
  var routes: Routes = [

    //{ path: '', component: environment ,canActivate: [MsalGuard]}

  // , canActivate:[MsalGuard],
   { path: '', component: LayoutComponent, pathMatch: 'full', children: [
    { path: '', component: HomeComponent,canActivate: [MsalGuard] }
    // {
    //   path: '',
    //   // pathMatch: 'full',
    //   component: HomeComponent,

    //   canActivate: [MsalGuard]
    // },
  ]},

];
}


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
